<template>
  <div :class="[$attrs.class, 'app-social-bar']">
    <ul>
      <li
        v-for="(socialLink, k) in socialLinks"
        :key="k"
        @click="(event) => sendTrackingEvent(socialLink.name, event, socialLink.url)"
      >
        <a :href="socialLink.url" target="_blank">
          <NuxtTransformImage
            :alt="socialLink.name"
            width="24"
            height="24"
            loading="lazy"
            :src="
              typeof socialLink.icon === 'object'
                ? socialLink.icon.filename
                : `/assets/artnight/icons/${socialLink.icon}`
            "
          />
        </a>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { useNuxtApp } from '#imports';
import { sendButtonClickedEvent } from '@/resources/tracking';
import { ROOT_PATH } from '@/resources/helpers';

defineOptions({
  inheritAttrs: false
});

const NuxtTransformImage = defineAsyncComponent(() => import('@/components/molecules/NuxtTransformImage.vue'));

interface Props {
  socialLinks: any[];
}

withDefaults(defineProps<Props>(), {
  socialLinks: () => []
});

function sendTrackingEvent(label: string, event: any, targetUrl: string) {
  const locationCityVal = targetUrl?.replaceAll(ROOT_PATH, '') || ' ';

  sendButtonClickedEvent({
    targetUrl,
    targetPath: targetUrl,
    label,
    elementId: label,
    buttonAction: 'link',
    locationCity: [locationCityVal]
  });
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/css_BASE/helpers/mixins/_bp.scss' as *;
@use '@/assets/styles/css_BASE/helpers/mixins/_box.scss' as *;

.app-social-bar {
  ul {
    list-style: none;
    overflow: hidden;
    display: flex;
    justify-content: space-around;
    max-width: 300px;
    @include bp(md) {
      margin-bottom: 70px;
    }

    li {
      float: left;
      margin-right: 32px;
      &:last-child {
        margin-right: 0;
      }
      a {
        @include box(24px, 24px);
        display: inline-block;

        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
